/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from "react";
import { HomeRequestProvider } from "./provider/HomeRequestProvider";
import { HomeResponseProvider } from "./provider/HomeResponseProvider";
import HomePage from "./HomePage";
import { useDispatch } from "react-redux";
import { setProjectResetData } from "../../common/ModalPopup/reducer";

const HomePageWrapper: FC = () => {
  const dispatch  = useDispatch()
  useEffect(() => {
   dispatch(setProjectResetData(null))
  },[])
  return (
    <HomeRequestProvider>
      <HomeResponseProvider>
        <HomePage />
      </HomeResponseProvider>
    </HomeRequestProvider>
  )
}

export default HomePageWrapper
